export var adbSchemeWiseDetailsMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                key: item.key,
                value: item.value.map(function (items) {
                    return {
                        categoryId: items.categorY_ID,
                        categoryName: items.categorY_NAME,
                        subcategoryId: items.subcategorY_ID,
                        subcategoryName: items.subcategorY_NAME,
                        actual: items.actual,
                        actualMin: items.actuaL_MIN,
                        postConsumption: items.posT_CONSUMPTION,
                        postConsumptionMin: items.posT_CONSUMPTION_MIN,
                        postExpire: items.posT_EXPIRY,
                        postExpireMin: items.posT_EXPIRY_MIN,
                        value: items.value,
                    };
                }),
            };
        });
    }
    return result;
};
